export default "چیست\nیا\nکجا\nچه چیزی\nچگونه\nچه\nچند تا\nچند\nچقدر\nچه باید کرد"